import React, { Fragment, useEffect, useState } from 'react';
import { Box, Divider } from '@mui/material';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ExampleWrapperSimple } from '../../layout-components';
import { LeftSidebar } from 'layout-blueprints';
import UnitForm from 'modules/batchUnit/components/UnitForm';
import DataTable from 'pages/Manage/DataTable';
import StandardHeader from '../../components/global/StandardHeader';

const BatchUnit = (props) => {
  const [data, setData] = useState([]);
  const [propertyManager, setPropertyManager] = useState({})
  const [pmCustomerType, setPmCustomerType] = useState({});
  const [activeAccountStatus, setActiveAccountStatus] = useState({});
  const [shouldBlockNavigation, setShouldBlockNavigation] = useState(false)
  const onGenerateDataTable = (dataTable, selectedPM, pmCustomerType, activeAccountStatus) => {
    setData(dataTable);
    setPropertyManager(selectedPM)
    setPmCustomerType(pmCustomerType)
    setActiveAccountStatus(activeAccountStatus)

  }

  useEffect(() => {
    if (shouldBlockNavigation) {
      window.onbeforeunload = () => true
    } else {
      window.onbeforeunload = undefined
    }
  }, [props.user.details]);


  const pageTitle = props.properties.data.property.id 
    ? `Batch Units: ${props.properties.data.property.name}`
    : "Batch Unit Generator";
  
  document.title = pageTitle;

  return (
    <Fragment>
      <LeftSidebar>
        <StandardHeader
          title="Batch Add Units"
          appPath="Management / Batch Units"
        />
        <Divider className="mb-3 mt-3" />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box sx={{ width: '100%' }}>
            <ExampleWrapperSimple sectionHeading="Configure Units">
              <UnitForm onGenerateDataTable={onGenerateDataTable} />
            </ExampleWrapperSimple>
          </Box>
          {data.length > 0 && (
            <Box sx={{ width: '100%' }}>
              <ExampleWrapperSimple sectionHeading="Review & Edit">
                <DataTable 
                  data={data} 
                  selectedPM={propertyManager} 
                  pmCustomerType={pmCustomerType} 
                  activeAccountStatus={activeAccountStatus} 
                />
              </ExampleWrapperSimple>
            </Box>
          )}
        </Box>
      </LeftSidebar>
    </Fragment>
  );
}


BatchUnit.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  units: PropTypes.object.isRequired,
  propertyManagers: PropTypes.object.isRequired,
  properties: PropTypes.object.isRequired,
};

// Component State
function BatchUnitState(state) {
  return {
    user: state.user,
    apl: state.apl,
    units: state.units,
    propertyManagers: state.propertyManagers,
    properties: state.properties
  };
}

export default connect(BatchUnitState, {})(BatchUnit);

